<template>
  <div class="d-flex flex-column">
    <div class="mb-4">
      <p class="ma-0 pa-0 mb-1 caption blue-grey--text text--darken-1">
        {{ $t('routines.executed_by') }}
      </p>
      <ChipAvatar small :account="createdBy" />
    </div>
    <div class="mb-4">
      <p class="ma-0 pa-0 mb-1 caption blue-grey--text text--darken-1">
        {{ $t('common.description') }}
      </p>
      <p
        v-if="description"
        class="ma-0 pa-0 mb-1 body-1 blue-grey--text text--darken-3"
      >
        {{ description }}
      </p>
      <p v-else class="ma-0 pa-0 mb-1 body-1 blue-grey--text text--darken-1">
        -
      </p>
    </div>
    <div class="mb-4">
      <p class="ma-0 pa-0 mb-1 caption blue-grey--text text--darken-1">
        {{ $t('common.type') }}
      </p>
      <v-chip
        v-if="type"
        small
        outlined
        color="blue-grey lighten-3"
        class="caption blue-grey--text text--darken-3 me-1"
      >
        {{ $t(`routines.type.${type}`) }}
      </v-chip>
      <p v-else class="ma-0 pa-0 mb-1 body-1 blue-grey--text text--darken-1">
        -
      </p>
    </div>
    <div class="mb-4">
      <p class="ma-0 pa-0 mb-1 caption blue-grey--text text--darken-1">
        {{ $t('common.category_other') }}
      </p>
      <ChipList
        outlined
        :totalItems="categories.length"
        :items="categories"
        :limit="3"
      />
    </div>
    <div class="mb-4">
      <p class="ma-0 pa-0 mb-1 caption blue-grey--text text--darken-1">
        {{ $t('common.tag_other') }}
      </p>
      <ChipList outlined :totalItems="tags.length" :items="tags" :limit="3" />
    </div>
    <div>
      <p class="ma-0 pa-0 mb-1 caption blue-grey--text text--darken-1">
        {{ $t('common.location') }}
      </p>
      <p
        v-if="site"
        class="ma-0 pa-0 mb-1 body-2 blue-grey--text text--darken-3"
      >
        {{ site }}
      </p>
      <p v-else class="ma-0 pa-0 mb-1 body-1 blue-grey--text text--darken-1">
        -
      </p>
    </div>
    <v-divider class="pa-0 ma-0 my-4" />
    <div class="d-flex align-start">
      <v-btn
        text
        plain
        rounded
        color="primary"
        class="ms-n4"
        :ripple="false"
        @click="showChecklist = !showChecklist"
      >
        {{ $t('checklist.checklist_one') }}
        <v-icon v-if="showChecklist" class="ms-1">mdi-chevron-up</v-icon>
        <v-icon v-else class="ms-1">mdi-chevron-down</v-icon>
      </v-btn>
    </div>
    <template v-if="showChecklist">
      <template v-for="(item, index) in checklist.items">
        <div
          v-if="item.type !== 'separator'"
          class="d-flex align-start mb-4"
          :key="item.name + index"
        >
          <v-icon color="blue" class="me-4" size="16"
            >mdi-card-text-outline
          </v-icon>
          <p class="ma-0 pa-0 caption blue-grey--text text--darken-2">
            {{ item.name }}
          </p>
        </div>
        <div v-else :key="item.name + index">
          <p class="text-overline ma-0 pa-0 grey--text text--darken-3">
            {{ item.name }}
          </p>
          <v-divider class="mt-1 mb-4" />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import ChipList from '@/components/ChipList.vue'
import ChipAvatar from '@/components/ChipAvatar.vue'

import { mapGetters } from 'vuex'
import api from '@/api'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'RoutineContent',

  mixins: [mixin],

  components: { ChipList, ChipAvatar },

  props: { routine: Object },

  data() {
    return {
      loading: false,
      checklist: [],
      showChecklist: true,
    }
  },

  watch: {
    'routine.checklist': {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue === oldValue || !newValue || !newValue?.length) return

        await this.getChecklist()
      },
    },
  },

  computed: {
    ...mapGetters(['organizationId']),

    createdBy() {
      return this.routine?.createdBy ?? ''
    },

    assignees() {
      return this.routine?.assignees ?? null
    },

    description() {
      return this.routine?.description ?? '-'
    },

    type() {
      return this.routine?.type ?? null
    },

    categories() {
      return (
        this.routine?.categories?.map?.(category =>
          this.$t(`common.categories.${category}`)
        ) ?? []
      )
    },

    tags() {
      return this.routine?.tags?.map?.(tag => tag.name) ?? []
    },

    site() {
      return this.routine?.site?.name ?? '-'
    },

    checklistId() {
      return this.routine?.checklist ?? null
    },
  },

  methods: {
    async getChecklist() {
      if (!this.checklistId) return
      try {
        const response = await api.checklist.getById(
          this.organizationId,
          this.checklistId
        )
        this.checklist = response.data
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
